
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy_policy",
      function () {
        return require("private-next-pages/privacy_policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy_policy"])
      });
    }
  